import React from 'react';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';

import OverlayLoading from '../../common/overlayLoading/OverlayLoading';
import ProjectCell from './projectCell/ProjectCell';
import { fetchProjects } from '../../helpers/DataProvider';

import './ProjectsList.css';

class ProjectsList extends React.Component {
  constructor() {
    super();

    this.state = {
      projects: [],
      isLoading: true,
    };
  }

  componentDidMount() {
    fetchProjects((projects) => {
      this.setState({ projects, isLoading: false });
    });
  }

  static renderProject(project) {
    return (
      <Link
        className="projectLink"
        key={project.projectid}
        to={{
          pathname: `/project/${project.title}`,
          state: { project },
        }}
      >
        <ProjectCell project={project} />
      </Link>
    );
  }

  render() {
    const { projects, isLoading } = this.state;

    return (
      <div id="projects-list-section">
        <div id="project-list">
          <OverlayLoading loading={isLoading} />
          {projects.map(project => ProjectsList.renderProject(project))}
          <MediaQuery query="(min-width: 425px)">
            { (projects.length > 0) && (projects.length % 4) !== 0 && <ProjectCell blank /> }
          </MediaQuery>
        </div>
      </div>
    );
  }
}

export default ProjectsList;
